import script from "./text.vue?vue&type=script&lang=js"
export * from "./text.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/i18n/de/text.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cd4bf33a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cd4bf33a', __exports__)) {
    api.reload('cd4bf33a', __exports__)
  }
  
}


export default __exports__